import React from "react";
import { Column, ColumnId } from ".";
import base from "./base";
import SMSStatusCellContent from "../components/SMSStatusCellContent";
import { MessageTemplateActions } from "../../../../../../types/MessageTemplateEnums";

function smsOrderCompletedStatus({
	width,
	onResize,
	language,
}: Column.Options) {
	return base(
		ColumnId.SMSOrderCompletedStatus,
		(item) => (
			<SMSStatusCellContent
				item={item}
				type={MessageTemplateActions.ORDER_SUCCESSFULLY_COMPLETED}
				language={language}
			/>
		),
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default smsOrderCompletedStatus;
